import React, {useContext} from "react";
import './TotalRankingStyles.css'
import styled from "styled-components";

import {HorizontalSeparator} from "../separators/Separators";
import TabTitle from "../../components/tabTitle/TabTitle";
import {useTranslation} from "react-i18next";
import TotalRankingPillsComponent from "./components/TotalRankingPillComponent";
import {TotalRankingContainerProps} from "../../containers/totalRanking/TotalRankingContainer";
import TabFooter from "../tabFooter/TabFooter";
import {RegionSelectedContext} from "../../contexts/RegionSelectedContext";
import HeaderContainer from "../Commons/HeaderContainer";
import BodyContainer from "../Commons/BodyContainer";
import FooterContainer from "../Commons/FooterContainer";
import TabHeader from "../tabHeader/TabHeader";
import TwoColumnsLayout from "../TwoColumnsLayout/TwoColumnsLayout";
import Tab from "../tab/Tab";


const TotalRankingContent: React.FC = () => {
  const { t } = useTranslation();

  // @ts-ignore
  const { regionSelected } = useContext(RegionSelectedContext);
  console.log(regionSelected);

  const currency = regionSelected == 'eu' ? 'M€' : 'M USD';

  return (
    <TwoColumnsLayout
      leftColumnChildren={
        <>
          <div className={'titleWrapperTR'}>
            <h3 className={'marginTop50'}>
              { t('totalRanking.subtitle', { currency }) }
            </h3>
            <HorizontalSeparator width={50}/>
          </div>
          <div className={'leftColumnContainer'}>
              <p className={'lineHeight1'}>
                  {t('totalRanking.paragraphContent')}
              </p>
          </div>
        </>
      }
      rightColumnChildren={
        <div className={'rightColumnContainer'}>
          <TotalRankingPillsComponent />
        </div>
      }
    />
  );
};

const TotalRankingContentContainer = styled.div`
  align-self: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;

  @media (min-width: 481px) {
    flex-direction: row;

    .right-column {
      min-width: 350px;
    }

    h3 {
      margin-top: 0px;
    }
  }
}
`;

const TotalRankingComponent: React.FC<TotalRankingContainerProps> = ({isTabSelected}) => {
    const {t} = useTranslation();

    // TODO: drop isTabSelected attribute from TabTitle
    const title = <TabTitle title={t('totalRanking.title')} isTabSelected={ isTabSelected }/>;
    const body = (
      <TotalRankingContentContainer>
        <TotalRankingContent />
      </TotalRankingContentContainer>
    );
    const footer = <TabFooter/>;

    return (
      <Tab
        title={ title }
        body={ body }
        footer={ footer }
        isOpen={ isTabSelected }
      />
    );
};

export default TotalRankingComponent;
